import React, { createContext, useContext, useState } from 'react';
import { clsx } from 'clsx';

const TabsCtx = createContext<{ active: string; setActive: (v: string) => void }>({
  active: '',
  setActive: () => {},
});

export function Tabs({
  defaultValue,
  children,
  className,
}: {
  defaultValue: string;
  children: React.ReactNode;
  className?: string;
}) {
  const [active, setActive] = useState(defaultValue);
  return (
    <TabsCtx.Provider value={{ active, setActive }}>
      <div className={className}>{children}</div>
    </TabsCtx.Provider>
  );
}

export function TabsList({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <div
      className={clsx('flex gap-1 border-b border-tg-border mb-4', className)}
    >
      {children}
    </div>
  );
}

export function TabsTrigger({ value, children }: { value: string; children: React.ReactNode }) {
  const { active, setActive } = useContext(TabsCtx);
  return (
    <button
      onClick={() => setActive(value)}
      className={clsx(
        'px-4 py-2 text-sm font-medium transition-colors border-b-2 -mb-px',
        active === value
          ? 'border-tg-accent text-tg-accent'
          : 'border-transparent text-tg-text-secondary hover:text-tg-text'
      )}
    >
      {children}
    </button>
  );
}

export function TabsContent({ value, children }: { value: string; children: React.ReactNode }) {
  const { active } = useContext(TabsCtx);
  if (active !== value) return null;
  return <div>{children}</div>;
}
